import React from 'react';

import Loader from '~/app/common/Loader';

export type RouterLoaderComponent = React.FC

const RouterLoader: RouterLoaderComponent = () => <Loader size="32" />;

export default RouterLoader;
